import {IonItem, IonList} from "@ionic/react";
import React from "react";
import {IFormProps} from "../../component/form/model/FormModel";
import BasicForm from "../../component/form/BasicForm";
import ApiResponseVO from "../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../ts/manager/Manager";
import InputFIE from "../../component/form/form-item-element/InputFIE";
import AppButton from "../../element/button/AppButton";


interface IPasswordResetProps extends IFormProps
{
    includeAccountButtons?: boolean;
}

export default class AccountPasswordResetForm extends BasicForm
{
    props: IPasswordResetProps;
    defaultSuccessMessage:string = "An email has been sent to you to reset your password";

    constructor(props: IPasswordResetProps)
    {
        super(props);

        this.props = props;
    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);
        return await getManager().api.fetchData("/account/password/reset", "POST", params, true);
    }

    renderComponent()
    {

        return <>

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            onSubmit={this.handleFormSubmit}
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >
                            {this.startFormAlerts()}
                            {this.requiredFieldsMessage()}

                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <InputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "username",
                                            name: "Email Address",
                                            required: true,
                                            errorMessages: {
                                                required: "Please enter your email address"
                                            }
                                        }}
                                        elementProps={{
                                            type: "email"
                                        }}
                                    />
                                </div>
                            </div>


                            {this.endFormAlerts()}

                            <div className="clearfix">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type="submit"
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Reset Password
                                    </AppButton>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </>;
    }
}